var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttons-cta"},[_c('button',{staticClass:"buttons-cta-explore",on:{"click":function($event){return _vm.$emit('clickFunctionExplore')}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }